import * as React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Moment from "react-moment";
import { getDateConvertedFromUTC } from "util/UtilityFunctions";

function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row?.meta.sentBy}
        </TableCell>
        <TableCell align="right">{row?.meta.totalRecipient}</TableCell>
        <TableCell align="right">{row?.meta.totalDelivered}</TableCell>
        <TableCell align="right">{row?.meta.totalUndelivered}</TableCell>
        <TableCell align="right">{row?.meta.totalBlocked}</TableCell>
        <TableCell align="right">
          <Moment format="HH:mm">{getDateConvertedFromUTC(row?.meta.blastSentAt)}</Moment> ({" "}
          <Moment format="LL">{getDateConvertedFromUTC(row?.meta.blastSentAt)}</Moment>)
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
                {"Message : "}
                {row?.message.message}
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead sx={{ display: "table-header-group!important" }}>
                  <TableRow>
                    <TableCell>Recipient Phone</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Sent At</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row?.logsMeta.map((logRow) => (
                    <TableRow key={logRow.recipientPhone}>
                      <TableCell component="th" scope="row">
                        {logRow.recipientPhone}
                      </TableCell>
                      <TableCell>{logRow.status}</TableCell>
                      <TableCell>
                        <Moment format="lll">{getDateConvertedFromUTC(logRow?.createdAt)}</Moment>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default function LogDetailsCollapsibleTable({ logsMeta }) {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table">
        <TableHead sx={{ display: "table-header-group!important" }}>
          <TableRow>
            <TableCell />
            <TableCell>Sent By</TableCell>
            <TableCell align="right">Total Recipients</TableCell>
            <TableCell align="right">Total Delivered</TableCell>
            <TableCell align="right">Total Undelivered</TableCell>
            <TableCell align="right">Total Blocked</TableCell>
            <TableCell align="right">Blast Sent At</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {logsMeta.map((row) => (
            <Row key={row.name} row={row} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
